(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hk-library-nav"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hk-library-nav')) {
  customElements.define('hk-library-nav', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const app = 'https://headknobs-studio-production.up.railway.app';
      const key = 'headknobs.hasSavedKnobs.v1';
      const frame = this.querySelector('iframe');
      const link = this.querySelector('a');
      const apply = hasKnobs => {
        link.textContent = hasKnobs ? this.dataset.returnLabel : this.dataset.label;
        link.href = hasKnobs ? this.dataset.library : this.dataset.upload;
        link.hidden = !hasKnobs && this.dataset.hideEmpty === 'true';
      };
      const restore = () => { try { apply(localStorage.getItem(key) === '1'); } catch { apply(false); } };
      const query = () => frame.contentWindow?.postMessage({ type: 'hk:library-query', version: 1 }, app);
      window.addEventListener('message', event => {
        const builder = document.querySelector('hk-builder-embed iframe');
        if (event.origin !== app || (event.source !== frame.contentWindow && event.source !== builder?.contentWindow)) return;
        const data = event.data;
        if (data?.type !== 'hk:library-state' || data.version !== 1 || data.available !== true || typeof data.hasKnobs !== 'boolean') return;
        try { localStorage.setItem(key, data.hasKnobs ? '1' : '0'); } catch {}
        apply(data.hasKnobs);
      }, { signal });
      frame.addEventListener('load', query, { signal });
      window.addEventListener('pageshow', () => { restore(); query(); }, { signal });
      window.addEventListener('focus', query, { signal });
      window.addEventListener('storage', event => { if (event.key === key || event.key === null) restore(); }, { signal });
      restore(); query();
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
